import { Routes, Route, Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import LangGuard from './LangGuard';
import Home from '@/pages/Home/Home';
import ExpoPage from '@/pages/ExpoPage/ExpoPage';
import ErrorPage from '@/pages/ErrorPage/ErrorPage';

export default function AppRoutes() {
    const { i18n } = useTranslation();

    return (
        <Routes>
            <Route index element={<Navigate to={i18n.language} />} />
            <Route path="/:lang/*" element={<LangGuard />}>
                <Route index element={<Home />} />
                <Route path=":web_path" element={<ExpoPage />} />
                <Route path="*" element={<ErrorPage />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
}
